import { OrganizationStatusEnum } from '@salescore/client-api'
import { type ProgressType, useMe } from '@salescore/client-common'
import type { CompiledKpiPivotViewConfig, CompiledKpiViewConfig } from '@salescore/core'
import dayjs from 'dayjs'
import { useMemo } from 'react'

import { calculateAverageProgressService } from '../recoil/navigation/selector/calculateAverageProgressService'
import { usePeriod } from './usePeriod'

export const useProgress = (compiledConfig: CompiledKpiViewConfig | CompiledKpiPivotViewConfig): ProgressType => {
  const [period] = usePeriod()
  const me = useMe()
  const [component] = compiledConfig.ui
  const todayKey = dayjs().format('YYYY-MM-DD')
  const isDemo = me.organization.status === OrganizationStatusEnum.Demo

  return useMemo(
    () =>
      calculateAverageProgressService({
        startAt: period?.startAt,
        endAt: period?.endAt,
        startOfToday: dayjs(todayKey).startOf('day'),
        isDemo,
        pivot: component.pivot,
        businessDays: me.organization.businessDays,
      }),
    [period?.startAt, period?.endAt, todayKey, isDemo, component.pivot, me.organization.businessDays],
  )
}
